// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".leaflet-control-pos {\n  color: rgba(204, 204, 204, 0.9);\n  padding: 4px;\n  width: 280px;\n  font-size: 16px;\n  text-align: center;\n}\n.leaflet-control-pos p {\n  margin: 0;\n}\n.leaflet-bottom .leaflet-control-pos {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  margin-bottom: 5px;\n  background: rgba(0, 0, 0, 0.3);\n}\n", ""]);
// Exports
module.exports = exports;
